import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = {
  slot: "end",
  class: "end-content"
}
const _hoisted_5 = {
  key: 0,
  class: "time-slot"
}
const _hoisted_6 = { class: "time" }
const _hoisted_7 = { class: "time" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_item_group = _resolveComponent("ion-item-group")!
  const _component_pull_to_refresh = _resolveComponent("pull-to-refresh")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, { class: "page-wrapper" }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, {
        class: "ionic-header ion-no-border",
        mode: "ios",
        "no-border": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, {
            class: "toolbar",
            mode: "ios",
            "no-padding": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_title, { class: "title" }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode(" Planning ", -1)
                ]))]),
                _: 1
              }),
              (_openBlock(), _createElementBlock("svg", {
                slot: "end",
                class: "logout",
                fill: "fill",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
              }, [...(_cache[4] || (_cache[4] = [
                _createElementVNode("path", {
                  d: "M17 7L15.59 8.41L18.17 11H8V13H18.17L15.59 15.58L17 17L22 12L17 7ZM4 5H12V3H4C2.9 3 2 3.9 2 5V19C2 20.1 2.9 21 4 21H12V19H4V5Z",
                  fill: "fill"
                }, null, -1)
              ]))]))
            ]),
            _: 1
          }),
          _createVNode(_component_ion_toolbar, {
            class: "planning-types",
            mode: "md"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_segment, {
                value: _ctx.segmentState ? 'finished' : 'todo'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_segment_button, {
                    class: "filter-btn",
                    value: "todo",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fetchAllOrders(false)))
                  }, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createTextVNode(" Te doen ", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_ion_segment_button, {
                    class: "filter-btn",
                    value: "finished",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.fetchAllOrders(true)))
                  }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode(" Afgerond ", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        fullscreen: true,
        class: "ion-content-container"
      }, {
        default: _withCtx(() => [
          (_ctx.planning)
            ? (_openBlock(), _createElementBlock("main", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.planning, (day, key, index) => {
                  return (_openBlock(), _createElementBlock("section", {
                    key: `planning-${index}`,
                    class: "planning"
                  }, [
                    _createElementVNode("h2", _hoisted_2, _toDisplayString(key[0].toUpperCase() + key.substring(1)), 1),
                    _createVNode(_component_ion_item_group, { class: "group" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(day, (planning, index) => {
                          return (_openBlock(), _createBlock(_component_ion_item, {
                            key: index,
                            class: "item ion-activatable ripple-parent",
                            onClick: ($event: any) => (_ctx.moveToOrderDetail(planning))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_3, [
                                _createVNode(_component_ion_label, { class: "type" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(planning.appointment_type), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_ion_label, { class: "name" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(planning.name) + ", " + _toDisplayString(planning.city), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                (_ctx.user.isPlanner)
                                  ? (_openBlock(), _createBlock(_component_ion_label, {
                                      key: 0,
                                      class: "mechanic-name"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(planning.mechanic_name), 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_4, [
                                (planning.timeslot)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.reformatTimeslot(planning.timeslot)[0]), 1),
                                      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.reformatTimeslot(planning.timeslot)[1]), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createVNode(_component_ion_ripple_effect)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_pull_to_refresh)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}